import React from 'react';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import accessibilityButton from 'assets/images/accessibility.png';
import ImageButton from './ImageButton';
import { Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { remCalc } from '@monorepo/shared/src/util/style-util';
import { FONT_GSS_FUTURA } from '@monorepo/shared/src/themes/defaultTheme';
import { AppRoutes } from '@monorepo/shared/src/types';
import { ButtonProps } from './Button';

const t = (key: string) => translate('a11y', key);

const AccessibilityButton: React.FC<ButtonProps> = (props) => {
  const classes = useStyles();
  return (
    <Box className={classes.buttonContainer}>
      <ImageButton
        hoveredImgSrc={accessibilityButton}
        notHoveredImgSrc={accessibilityButton}
        imgAlt={t('alt.accessibilityButton')}
        redirectRoute={{ path: `/${AppRoutes.HOME}`, title: AppRoutes.HOME }}
        {...props}
      />
      {props.showTextLabel && (
        <Box className={classes.label}>{t('buttonsLabel.accessibilityLabel')}</Box>
      )}
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  buttonContainer: {
    width: remCalc(80),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
  },
  label: {
    paddingTop: remCalc(88),
    textAlign: 'center',
    fontFamily: FONT_GSS_FUTURA,
    position: 'absolute',
    top: '0px',
  },
}));

export default AccessibilityButton;
